export default __webpack_public_path__ + "6936b2070e14f7f641cd937f03bcd548.webp";